import { Verdict } from '@exam-management/graphql';
import { Card, type CardProps, Flex, mergeSx } from '@shared/components';

import {
  type QuestionSubTaskComment,
  type QuestionSubTaskVerdict,
  type SubtaskDetailsData,
} from '../../types';
import { Comment } from '../comment';
import { VerdictSubTaskInfoSection } from '../verdict-sub-task-info-section';
export type VerdictSubTaskCardProps = Pick<CardProps, 'sx'> & {
  subtask: SubtaskDetailsData;
  verdict: QuestionSubTaskVerdict | null;
  comments: QuestionSubTaskComment[];
};
const VERDICT_STATUS_COLOR = {
  [Verdict.Approved]: 'success.main',
  [Verdict.Rejected]: 'error.main',
};

export default function VerdictSubTaskCard(props: Readonly<VerdictSubTaskCardProps>) {
  const { subtask, verdict, comments, sx } = props;
  const { assignee, code, assignedAt, submittedAt } = subtask;
  const assigneeName = `${assignee.firstname} ${assignee.lastname}`;
  if (!verdict || !verdict.verdict) {
    return null;
  }
  const borderColor =
    VERDICT_STATUS_COLOR[verdict.verdict as keyof typeof VERDICT_STATUS_COLOR] ?? 'grey.500';
  return (
    <Card
      elevation={0}
      sx={mergeSx(
        (theme) => ({
          border: '1px solid',
          borderColor: theme.palette.grey[300],
          borderRadius: theme.shape.rounded(2),
          px: theme.spacing(4),
          py: theme.spacing(3),
        }),
        sx,
      )}
    >
      <Flex sx={(theme) => ({ alignItems: 'center', gap: theme.spacing(4) })}>
        {/* Add content here */}
        <Flex
          sx={(theme) => ({
            flex: 1,
            flexDirection: 'column',
            gap: theme.spacing(3),
            borderLeft: '4px solid',
            borderColor,
            pl: theme.spacing(3),
          })}
        >
          <VerdictSubTaskInfoSection
            isShowAssignee={comments.length === 0}
            assigneeName={assigneeName}
            code={code}
            assignedAt={assignedAt}
            submittedAt={submittedAt}
            verdict={verdict}
          />
          {comments && comments.length > 0
            ? comments.map((comment) => <Comment key={comment.id} comment={comment} />)
            : null}
        </Flex>
      </Flex>
    </Card>
  );
}
